// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"Checkbox_checkboxGroup__Rd95r","input":"Checkbox_input__CCaLJ","label":"Checkbox_label__DazT4","checkmark":"Checkbox_checkmark__rjAaD"};